const theme = {
  palette: {
    mode: 'light',
    primary: {
      main: '#0062FF',
      light: '#68A2FF',
    },
    text: {
      secondary: '#898E96',
    },
    error: {
      main: '#F94C4C',
    },
    /*secondary: {
      main: '#EBEDF0',
    },
    info: {
      main: '#3A3C41',
    },
    tonalOffset: 0.115,*/
  },
  typography: {
    /*button: {
      fontSize: '14px',
      lineHeight: '18px',
      textAlign: 'center',
      textTransform: 'none',
    },
    h2: {
      fontSize: '32px',
      lineHeight: '36px',
    },*/
    h3: {
      fontSize: '28px',
      lineHeight: '34px',
      fontWeight: 500,
    },
    h4: {
      fontSize: '24px',
      lineHeight: '30px',
      fontWeight: 500,
    },
    h5: {
      fontSize: '20px',
      lineHeight: '24px',
      fontWeight: 500,
    },
    h6: {
      fontSize: '18px',
      lineHeight: '22px',
    },
    body1: {
      fontSize: '14px',
      lineHeight: '18px',
    },
    body2: {
      fontSize: '16px',
      lineHeight: '22px',
    },
    caption: {
      fontSize: '12px',
      lineHeight: '14px',
      letterSpacing: '0.2px',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        sizeLarge: {
          fontSize: '16px',
          lineHeight: '22px',
          padding: '13px 16px',
          letterSpacing: '0.1px',
          boxShadow: 'none',
        },
        sizeMedium: {
          fontSize: '14px',
          lineHeight: '18px',
          padding: '10px 16px',
          boxShadow: 'none',
        },
        sizeSmall: {
          fontSize: '14px',
          lineHeight: '18px',
          padding: '6.5px 16px',
        },
      },
    },
  },
};

export { theme };
